import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-integrate-supervisory-task-rule-creat',
  templateUrl: './integrate-supervisory-task-rule-creat.component.html',
  styleUrls: ['../parts.css']
})
export class IntegrateSupervisoryTaskRuleCreatComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  supervisoryStatus: string;
  supervisoryStatusText = '状态';
  supervisoryStatusVisible = false;
  supervisoryVisible = false;
  supervisoryId: string;
  supervisoryDisplayText = '监控项';
  categorieId: string; // 存放当前目录ID
  instanceData: any = {}; // 存放实例返填数据
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组';
  supervisoryData = [];
  supervisoryStatusData = [];
  taskDefId: string; // 任务规则ID
  taskText = '任务规则';
  taskVisible = false;
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  backFillData: any;
  automation = {
    boardId: '',
    // groupId: '',
    categoryId: '',
    relationId: '',
    taskDefId: '',
    // operationOrgCode: '',
    // operationRoleCode: '',
    indicatorItemId: '',
    status: '',
    // workDefId: '',
    schedulerDescription: '',
    instanceDescription: '',
    indicatorExecutionStatus: '',
    conditions: [{}],
    taskMapping: {},
    pulseMapping: {}
  }; // 存放入参数据
  nodes = [];
  operationOrgCode = null;
  operationOrgDisplayText = '部门';
  operationOrgVisible = false;
  operationOrgData = [];
  operationRoleCode = null;
  operationRoleDisplayText = '岗位';
  operationRoleVisible = false;
  operationRoleData = [];
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private message: NzMessageService,
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    this.getIndicatorItemsData();
    this.getTaskRuleListData();
    this.supervisoryStatusData = [
      // {
      //   id: 'normal',
      //   name: '正常'
      // },
      {
        id: 'abnormal',
        name: '异常'
      },
      // {
      //   id: 'in_progress',
      //   name: '扫描中'
      // },
      // {
      //   id: 'error',
      //   name: '错误'
      // },
      // {
      //   id: 'interrupt',
      //   name: '中断'
      // }
    ];
    // 处理返填数据
    // 反填分组
    // this.groupConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.groupId : '';
    // this.boardGroupData.forEach((item, index) => {
    //   if (item.id === this.groupConditionId) {
    //     this.groupConditionDisplayText = item.title;
    //   }
    // });
    if (this.instanceData && this.instanceData.config) {
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
    }
    // 带入菜单ID
    this.supervisoryId = this.automation.indicatorItemId;
    this.supervisoryStatus = this.automation.indicatorExecutionStatus;
    // this.operationRoleCode = this.automation.operationRoleCode;
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.supervisoryStatusData.forEach(item => {
      if (item.id === this.supervisoryStatus) {
        this.supervisoryStatusText = item.name;
      }
    });
    // this.getDepartment();
    this.packageData();
  }
  openTaskDialog() {
    if (!this.supervisoryId) {
      this.message.create('warning', '请先选择监控项！');
      return;
    }
    this.isVisible = true;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '当监听到' + this.supervisoryDisplayText + '的状态为' + this.supervisoryStatusText + '时，在' + this.operationOrgDisplayText + '及' + this.operationRoleDisplayText + '下，根据任务规则，创建任务';
    this.nfDataChange.emit(this.automation);
  }
  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.supervisoryId && this.supervisoryStatus && this.taskDefId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  supervisoryChange(item) {
    this.supervisoryDisplayText = item.name;
    this.supervisoryId = item.id;
    this.supervisoryVisible = false;
    this.automation.indicatorItemId = this.supervisoryId;
    this.packageData();
  }
  supervisoryStatusChange(item) {
    this.supervisoryStatusText = item.name;
    this.supervisoryStatus = item.id;
    this.supervisoryStatusVisible = false;
    this.automation.indicatorExecutionStatus = this.supervisoryStatus;
    this.packageData();
  }
  // groupConditionChange(item) {
  //   this.groupConditionDisplayText = item.title;
  //   this.groupConditionId = item.id;
  //   this.automation.groupId = this.groupConditionId;
  //   this.groupConditionVisible = false;
  //   this.packageData();
  // }
  // 获取监控列表
  getIndicatorItemsData() {
    this.taskService.getIndicatorItems().subscribe((res: any) => {
      this.supervisoryData = res && res._embedded ? res._embedded.vos : [];
      this.supervisoryData.forEach(item => {
        if (item.id === this.supervisoryId) {
          this.supervisoryDisplayText = item.name;
        }
      });
    });
  }
  // 获取任务规则列表
  getTaskRuleListData() {
    this.taskService.getManualTaskData(this.boardGroupData[0].boardId).subscribe((res: any) => {
      const data = res && res._embedded ? res._embedded.vos : [];
      this.nodes = this.listConvertTree(data);
      this.nodes = this.handleTreeData(this.nodes);
      this.taskDefId = this.automation.taskDefId;
    });
  }
  onTaskChange($event) {
    this.automation.taskDefId = $event;
  }
  // 平级转树形数据
  listConvertTree(data) {
    // 没有父节点的数据
    const parents = data.filter(value => value.parentId === 'undefined' || value.parentId == null);
    // 有父节点的数据
    const children = data.filter(value => value.parentId !== 'undefined' && value.parentId != null);
    const translator = (parents, children) => {
      // 遍历父节点数据
      parents.forEach((parent) => {
          // 遍历子节点数据
          children.forEach((current, index) => {
              // 此时找到父节点对应的一个子节点
              if (current.parentId === parent.id) {
                // 对子节点数据进行深复制，这里只支持部分类型的数据深复制
                const temp = JSON.parse(JSON.stringify(children));
                // 让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
                temp.splice(index, 1);
                // 让当前子节点作为唯一的父节点，去递归查找其对应的子节点
                translator([current], temp);
                // 把找到子节点放入父节点的children属性中
                if (parent.children && parent.children.length) {
                  parent.children.push(current);
                } else {
                  parent.children = [current];
                }
                // typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];
              }
            }
          );
        }
      );
    };
    translator(parents, children);
    return parents;
  }
  handleTreeData(data) {
    data.forEach(item => {
      item.title = item.name;
      item.key = item.id;
      if (item.children && item.children.length) {
        this.handleTreeData(item.children);
      } else {
        item.isLeaf = true;
      }
    });
    return data;
  }
  // operationOrgChange(item) {
  //   this.operationOrgDisplayText = item.name;
  //   this.operationOrgCode = item.id;
  //   this.operationOrgVisible = false;
  //   this.automation.operationOrgCode = this.operationOrgCode;
  //   const params = {orgCode: item.code};
  //   this.getJob(params);
  //   this.packageData();
  // }
  // operationRoleChange(item) {
  //   this.operationRoleCode = item.roleId;
  //   this.operationRoleDisplayText = item.roleName;
  //   this.operationRoleVisible = false;
  //   this.automation.operationRoleCode = this.operationRoleCode;
  //   this.packageData();
  // }
  // getDepartment() {
  //   this.taskService.getTaskDepartment().subscribe( res => {
  //     this.operationOrgData = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
  //     this.operationOrgCode = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.operationOrgCode : '';
  //     this.operationOrgData.forEach(item => {
  //       if (item.id === this.operationOrgCode) {
  //         this.operationOrgDisplayText = item.name;
  //         const params = {orgCode: item.code};
  //         this.getJob(params);
  //       }
  //     });
  //   });
  // }
  // getJob(params) {
  //   this.sys.getProductJob(params).subscribe( res => {
  //     this.operationRoleData = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
  //     this.operationRoleCode = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.operationRoleCode : '';
  //     this.operationRoleData.forEach(item => {
  //       if (item.roleId === this.operationRoleCode) {
  //         this.operationRoleDisplayText = item.roleName;
  //       }
  //     });
  //   });
  // }
}
